import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

// Iconos de Ionic
import { addIcons } from 'ionicons';
import {
  mailOutline,
  lockClosedOutline,
  personOutline,
  eyeOutline,
  eyeOffOutline,
  informationCircle,
  checkmarkCircle,
  warning,
  closeCircle,
  close,
  hourglassOutline,
  checkmark,
  arrowForward,
  arrowBack,
  add,
  remove,
  refresh,
  search,
  menu,
  home,
  settings,
  logOut,
  sunnyOutline,
  moonOutline,
  phonePortraitOutline,
  contrastOutline,
  languageOutline,
  chevronDownOutline,
  chevronUpOutline,
  arrowUpCircle,
  arrowDownCircle,
  removeCircle,
  laptopOutline,
  peopleOutline,
  cardOutline,
  settingsOutline,
  trendingUpOutline,
  flagOutline,
  businessOutline,
  radioButtonOnOutline,
  radioButtonOn,
  chevronBackOutline,
  personCircleOutline,
  notificationsOutline,
  person,
  chevronDown,
  addCircle,
  construct,
  shieldCheckmark,
  repeat,
  trash,
  chevronForward,
  logOutOutline,
  colorPaletteOutline,
  chevronForwardOutline,
  qrCodeOutline,
  cameraOutline,
  refreshOutline,
  alertCircle,
  timeOutline,
  addOutline,
  listOutline,
  searchOutline,
  cubeOutline,
  checkmarkCircleOutline,
  constructOutline,
  pricetagOutline,
  calendarOutline,
  cogOutline,
  documentTextOutline,
  carOutline,
  shieldCheckmarkOutline,
  shieldOutline,
  alertCircleOutline,
  documentOutline,
  barcodeOutline,
  cloudUploadOutline,
  checkmarkOutline,
  imagesOutline,
  trashOutline,
  printOutline,
  print,
  returnUpForward,
  playCircleOutline,
  pauseCircleOutline,
  stopCircleOutline,
  navigateOutline,
  arrowForwardCircle,
  returnDownBack,
  informationCircleOutline,
  stopCircle,
  swapHorizontalOutline,
  checkmarkDoneCircleOutline,
  createOutline
} from 'ionicons/icons';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { authInterceptorFn } from './utilities/interceptors/auth-functional.interceptor';
import { spinnerInterceptor } from './utilities/interceptors/loading.interceptor';
import { EncryptionHelper } from './utilities/helper/encryption.helper';

// Registrar iconos globalmente
addIcons({
  mailOutline,
  lockClosedOutline,
  personOutline,
  eyeOutline,
  eyeOffOutline,
  informationCircle,
  checkmarkCircle,
  warning,
  closeCircle,
  close,
  hourglassOutline,
  checkmark,
  arrowForward,
  arrowBack,
  add,
  remove,
  refresh,
  search,
  menu,
  home,
  settings,
  logOut,
  sunnyOutline,
  moonOutline,
  phonePortraitOutline,
  contrastOutline,
  languageOutline,
  chevronDownOutline,
  chevronUpOutline,
  arrowUpCircle,
  arrowDownCircle,
  removeCircle,
  laptopOutline,
  peopleOutline,
  cardOutline,
  settingsOutline,
  trendingUpOutline,
  flagOutline,
  businessOutline,
  radioButtonOnOutline,
  chevronBackOutline,
  personCircleOutline,
  notificationsOutline,
  person,
  chevronDown,
  addCircle,
  construct,
  shieldCheckmark,
  repeat,
  trash,
  chevronForward,
  logOutOutline,
  colorPaletteOutline,
  chevronForwardOutline,
  qrCodeOutline,
  cameraOutline,
  refreshOutline,
  alertCircle,
  timeOutline,
  addOutline,
  listOutline,
  searchOutline,
  cubeOutline,
  checkmarkCircleOutline,
  constructOutline,
  pricetagOutline,
  calendarOutline,
  cogOutline,
  documentTextOutline,
  carOutline,
  shieldCheckmarkOutline,
  shieldOutline,
  alertCircleOutline,
  documentOutline,
  barcodeOutline,
  cloudUploadOutline,
  checkmarkOutline,
  imagesOutline,
  trashOutline,
  printOutline,
  print,
  playCircleOutline,
  pauseCircleOutline,
  stopCircleOutline,
  navigateOutline,
  arrowForwardCircle,
  returnDownBack,
  radioButtonOn,
  informationCircleOutline,
  stopCircle,
  returnUpForward,
  swapHorizontalOutline,
  checkmarkDoneCircleOutline,
  createOutline,
});

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      mode: 'md'   // Fuerza el estilo Android en iOS también
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    // Configurar HttpClient con interceptor funcional
    provideHttpClient(
      withInterceptors([spinnerInterceptor, authInterceptorFn])
    ),
    // Registrar EncryptionHelper como provider global
    EncryptionHelper,
  ],
});
